import React from 'react';
import { withTranslation } from 'react-i18next';
import './Banner.less';

class Banner extends React.Component {
	render() {
		const { t } = this.props;
		return (
			<div className="banner">
				<div className="banner__title">
					<h3>{t('banner_title')}</h3>
				</div>
				<div className="banner__sub-title">
					<p>{t('banner_text1')}</p>
					<p>{t('banner_text2')}</p>
					<p>{t('banner_text3')}</p>
				</div>
			</div>
		);
	}
}

export default withTranslation('translations')(Banner);
